export const RANK_THRESHOLDS = [
  { rank: "platinum", min: 1000 },
  { rank: "gold", min: 400 },
  { rank: "silver", min: 150 },
  { rank: "bronze", min: 50 },
  { rank: "none", min: 0 },
];

export const RANK_COLORS = {
  platinum: "text-purple-700 bg-purple-50 border-purple-200",
  gold: "text-amber bg-amber/10 border-amber/30",
  silver: "text-walnut-light bg-stone/30 border-stone",
  bronze: "text-terracotta bg-terracotta/10 border-terracotta/30",
  none: "text-walnut-light bg-cream border-stone",
};

export const RANK_SHIELD_CONFIG = {
  platinum: {
    label: "Platinum",
    gradient: "linear-gradient(160deg, #7c3aed 0%, #C2703E 100%)",
    border: "#a78bfa",
    text: "#f5f3ff",
    glow: "0 0 8px rgba(124, 58, 237, 0.35)",
    animate: true,
  },
  gold: {
    label: "Gold",
    gradient: "linear-gradient(160deg, #D4943A 0%, #f5c76b 100%)",
    border: "#D4943A",
    text: "#7c2d12",
    glow: "0 0 6px rgba(212, 148, 58, 0.20)",
    animate: false,
  },
  silver: {
    label: "Silver",
    gradient: "linear-gradient(160deg, #D1C7B8 0%, #e8e2d8 60%, #c4baa8 100%)",
    border: "#b8ad9e",
    text: "#44403c",
    glow: "none",
    animate: false,
  },
  bronze: {
    label: "Bronze",
    gradient: "linear-gradient(160deg, #C2703E 0%, #d4956a 100%)",
    border: "#A85A30",
    text: "#fff7ed",
    glow: "none",
    animate: false,
  },
  none: {
    label: "Unranked",
    gradient: "linear-gradient(160deg, #F0E9DF 0%, #e8e0d4 100%)",
    border: "#D1C7B8",
    text: "#6B5D4F",
    glow: "none",
    animate: false,
  },
};

export const URGENCY_COLORS = {
  critical: "text-white bg-coral",
  high: "text-white bg-amber",
  medium: "text-walnut bg-sage/20",
  low: "text-walnut-light bg-stone/30",
};

export const URGENCY_LABELS = {
  critical: "Critical",
  high: "High",
  medium: "Medium",
  low: "Low",
};

export const CATEGORY_LABELS = {
  volunteering: "Volunteering",
  food: "Food",
  crowdfunding: "Crowdfunding",
  items: "Items",
};

export const STATUS_COLORS = {
  open: "text-sage-dark bg-sage/15",
  partially_filled: "text-amber bg-amber/15",
  filled: "text-walnut-light bg-stone/30",
  completed: "text-terracotta bg-terracotta/10",
  cancelled: "text-coral bg-coral/10",
};

export const STATUS_LABELS = {
  open: "Open",
  partially_filled: "Partially Filled",
  filled: "Filled",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const SEED_USERS = ["Nguyen", "Sachin", "Arthur", "Miguel"];
